import { basicValidation } from "../basicValidation";

export const externalLinkFieldValidation = {
    externalLink: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        title: (value: string) => basicValidation.resourceText.isValid(value, false, 100),
        description: (value: string) => basicValidation.resourceText.isValid(value, false, 10000),
        url: (value: string) => basicValidation.isValidUrl(value, false, 500),
        iconName: (value: string | null) => value === null || basicValidation.validateString(value, false, false, 0, 100),
        showInMenu: (value: boolean) => typeof value === 'boolean'
    }
}